import React from 'react';
import { ColorSwatch } from '../drawing';
import { IColorColor } from './StudyModal';

interface IStudyParameters {
	color?: string | IColorColor,
	name?: string,
	heading?: string,
}

interface IStudyModalParameterProps {
	param: IStudyParameters
	setColor: (color: string | IColorColor, type: string, name: string | undefined) => void
}

export const StudyModalParameter: React.FunctionComponent<IStudyModalParameterProps> = ({ param, setColor }) => (
	<div>
		{param.color ? <ColorSwatch top={ 0 } name={param.heading} type="param" setColor={setColor}
						color={ typeof param.color === "string" ? param.color : param.color.color} /> : <div />}
		<input type={param.name === 'studyOverZones' ? 'checkbox' : 'number'} />
		<div>
			{param.heading}
		</div>
	</div>
);